import React, { useState } from "react";
// import { Card, CardContent, Typography, FormGroup, FormControlLabel, Checkbox, Box } from "@mui/material";
// import DescriptionIcon from "@mui/icons-material/Description";
import { Box, Card, Checkbox, FormControlLabel, FormGroup, makeStyles, Typography } from "@material-ui/core";


const years = Array.from({ length: 11 }, (_, i) => 2024 - i);

const useStyles = makeStyles((theme) => ({
    yearFilterCard: {
      width: 250,
      height: 400,
    //   overflowY: "auto",
    //   overflowX: "hidden",
      boxShadow: "3px 3px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: 8,
    },
    yearFilterHeader: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      // backgroundColor: "#1C2A4D",
      background: "linear-gradient(90deg, #141E30 0%, #243B55 100%)",
      padding: 10,
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
      color: "white",
    },
    yearFilterIcon: {
      color: "white",
      borderRadius: "50%",
    },
    yearFilterTitle: {
      color: "white",
      fontWeight: 600,
    },
    yearFilterGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 10,
    },
    yearFilterLabel: {
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      width: "100%",
      margin:'auto',
   },
   customCheckbox: {
    "&.Mui-checked": {
      color: "#4CAF50", // Green color when checked
    },
    "&.Mui-checked + span": {
      backgroundColor: "#E8F5E9", // Light green background
      borderRadius: "4px",
    },
  },
  }));

const YearFilter = ({uniqueYears , setSelectedYear , selectedYear}) => {
    


  const classes = useStyles();

  const handleChange = (year) => {
    setSelectedYear((prevSelectedYears) =>
      prevSelectedYears.includes(year)
        ? prevSelectedYears.filter((y) => y !== year) // Remove if already selected
        : [...prevSelectedYears, year] // Add if not selected
    );
  };

  return (
    <Card className={classes.yearFilterCard}>
      <Box className={classes.yearFilterHeader}>
        <Typography variant="h6" className={classes.yearFilterTitle}>
          Select Year
        </Typography>
      </Box>
      <FormGroup className={classes.yearFilterGroup}>
        {uniqueYears.map((year) => (
          <FormControlLabel
            key={year}
            control={
            <Checkbox checked={selectedYear.includes(year)} onChange={() => handleChange(year)} className={classes.customCheckbox} />
          }
            label={year}
            className={classes.yearFilterLabel}
          />
        ))}
      </FormGroup>
    </Card>
  );
};

export default YearFilter;
